import { createStore, applyMiddleware, combineReducers } from 'redux'
import { createTransform, persistStore, persistReducer } from 'redux-persist'
import { thunk, withExtraArgument } from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import storageSession from 'redux-persist/lib/storage/session'
import _ from 'lodash'
import filterOpenTokPublisher from './filter-opentok-publisher'

// Placeholder reducer to preserve state shape (react-router-redux removed)
const routingReducer = (state = {}) => state

// TODO: We should set up build params so that this is not enabled in prod
// Something like: process.env.ENABLE_DEVTOOLS ? composeWithDevTools : compose
const composeFn = composeWithDevTools

const createReduxStore = (reducers = {}, rehydratePersist = false, websocket = null) => {
  const combinedReducers = combineReducers({
    ...reducers,
    routing: routingReducer,
  })

  let rootReducer = combinedReducers

  if (rehydratePersist) {
    const publisherFilterTransform = createTransform(filterOpenTokPublisher, _.identity, { whitelist: ['global'] })
    const options = {
      key: 'root',
      blacklist: ['routing'],
      storage: storageSession,
      transforms: [publisherFilterTransform],
    }

    rootReducer = persistReducer(options, combinedReducers)
  }

  const preloadedState = undefined

  const enhancer = composeFn(
    applyMiddleware(
      websocket ? withExtraArgument({ emit: websocket.emit }) : thunk
    )
  )

  const store = createStore(rootReducer, preloadedState, enhancer)

  if (rehydratePersist) {
    persistStore(store)
  }

  return store
}

export default createReduxStore
